import React, { useEffect, useState } from "react";
import wazeIcon from "../../../assets/common/wazeIcon.svg";
import calendar from "../../../assets/common/calendar.svg";
import gift from "../../../assets/common/gift.svg";
import Cal from "../calendar/Cal";
const Links = (props) => {
  const [animate, setAnimate] = useState(
    "animate__animated animate__bounceInLeft animate__slow",
  );
  useEffect(() => {
    setTimeout(() => {
      setAnimate(
        "animate__animated animate__wobble animate__repeat-1 animate__slow",
      );
    }, 3000);
  }, []);
  const baseCardStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    color: "#3A3C3F",
    textDecoration: "none",
    padding: "14px 16px",
    borderRadius: "16px",
    minWidth: "80px",
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
    transition: "all 0.25s ease",
  };

  const calendarCardStyle = {
    ...baseCardStyle,
    background:
      "radial-gradient(circle at center, rgba(56, 142, 60, 0.28) 0%, rgba(56, 142, 60, 0.1) 65%, transparent 90%)",
  };

  const navigationCardStyle = {
    ...baseCardStyle,
    background:
      "radial-gradient(circle at center, rgba(33, 150, 243, 0.28) 0%, rgba(33, 150, 243, 0.1) 65%, transparent 90%)",
  };

  const giftCardStyle = {
    ...baseCardStyle,
    background:
      "radial-gradient(circle at center, rgba(255, 152, 0, 0.28) 0%, rgba(255, 152, 0, 0.1) 65%, transparent 90%)",
  };

  const labelStyle = { fontWeight: "600", textAlign: "center" };

  return (
    <div
      className="sss"
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-evenly",
        alignItems: "stretch",
        gap: "12px",
        fontSize: "12px",
        width: "100%",
        marginTop: "28px",
        padding: "0 16px",
      }}
    >
      <Cal
        data={props.data}
        token={props.token}
        div={
          <div
            style={calendarCardStyle}
            onMouseEnter={(e) => {
              e.currentTarget.style.boxShadow =
                "0 6px 20px rgba(33, 150, 243, 0.2)";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow = "0 2px 12px rgba(0,0,0,0.06)";
              e.currentTarget.style.transform = "translateY(0)";
            }}
          >
            <img
              alt="calendar"
              src={calendar}
              style={{ width: "28px", marginBottom: "6px" }}
            />
            {props.data.isEnglish ? (
              <div style={labelStyle}>Calendar</div>
            ) : (
              <div style={labelStyle}>הוספה ליומן</div>
            )}
          </div>
        }
      />
      {props.data.waze !== "" && (
        <a
          target={"_blank"}
          rel="noopener noreferrer"
          href={props.data.waze}
          style={navigationCardStyle}
          onMouseEnter={(e) => {
            e.currentTarget.style.boxShadow =
              "0 6px 20px rgba(56, 142, 60, 0.22)";
            e.currentTarget.style.transform = "translateY(-2px)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.boxShadow = "0 2px 12px rgba(0,0,0,0.06)";
            e.currentTarget.style.transform = "translateY(0)";
          }}
        >
          <img
            alt="wazeIcon"
            src={wazeIcon}
            style={{ width: "28px", marginBottom: "6px" }}
          />
          {props.data.isEnglish ? (
            <div style={labelStyle}>Navigation</div>
          ) : (
            <div style={labelStyle}>ניווט לאירוע</div>
          )}
        </a>
      )}
      {props.data.paybox !== "" && props.data.paybox !== undefined && (
        <a
          target={"_blank"}
          rel="noopener noreferrer"
          href={props.data.paybox}
          style={giftCardStyle}
          onMouseEnter={(e) => {
            e.currentTarget.style.boxShadow =
              "0 6px 20px rgba(255, 152, 0, 0.25)";
            e.currentTarget.style.transform = "translateY(-2px)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.boxShadow = "0 2px 12px rgba(0,0,0,0.06)";
            e.currentTarget.style.transform = "translateY(0)";
          }}
        >
          <img
            alt="gift"
            src={gift}
            style={{ width: "28px", marginBottom: "6px" }}
          />
          <div style={labelStyle}>מתנה באשראי</div>
        </a>
      )}
    </div>
  );
};

export default Links;
